<template>
  <v-container fluid class="pa-0">
    <Layout :hidePreview="$route.params.machineId === undefined"
      :hideFilter="$route.query[pk + 'filter'] === undefined"
      :hideOverlayRoute="$route.params.projectId == undefined">

      <template v-slot:filter>
        <FilterPane :title="'ffff'" :pk="pk">
          <template v-slot:filters-content>
            <CustomerSelect v-model="customersfilter" multiple clearable externaledit class="mt-5 mx-3">
            </CustomerSelect>
          </template>
        </FilterPane>
      </template>

      <template v-slot:list :pk="pk">
        <ListPane :getListMethod="getProjectListFromFilter" :optional-filters="filters" :paginationEnabled="true"
          :show-filter-tab="true" :show-sorting-tab="false" :itemsPerPage="50" ref="ListPane"
          :dialog-trigger="dialogtrigger" :dialogItem="editItem" :dialog-method-config="dialogMethodConfig" :pk="pk">

          <template v-slot:list-item="{ item }">
            <ListItem :item="item" @click="setEditItem(item)">
            </ListItem>
          </template>

          <template v-slot:dialog-content="{ item, trigger }">
             <EditContent :key="trigger" :item="item" :editMode="true" :handleFocus="() => { }">
            </EditContent>
          </template>

        </ListPane>
      </template>

    </Layout>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import CustomerSelect from "@/components/Inputs/EntityDropdowns/CustomerSelect2.vue";
import FilterPane from "@/components/Sections/Panes/FilterPane.vue";
import ListPane from "@/components/Sections/Panes/ListPane.vue";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import EditContent from "@/views/admin/projects/ProjectEditContent.vue";
import ListItem from "@/views/admin/projects/ProjectListItem.vue";
import Layout from "@/views/layouts/PreviewableList.vue";

export default {
  name: "AdminProjectsList",
  props: {},
  components: {
    ListPane,
    Layout,
    ListItem,
    EditContent,
    CustomerSelect,
    FilterPane,
  },
  mixins: [clientAPI, FilterQueryMixin],

  data() {
    return {
      pk: "PL-",
      editItem: null,
      dialogtrigger: 1,
      dialogMethodConfig: {
        Create: {
          IsClientApiMethod: true,
          Name: 'createProject',
        },
        Change: {
          IsClientApiMethod: true,
          Name: 'changeProject',
        },
      },
    };
  },

  mounted() { },

  methods: {
    openItem(item) {
      var query = (this.$route.name == "Projects") ? this.$route.query : undefined; //keep query filters if we are not leaving the current node branch
      this.$router.push({ name: 'ViewProject', params: { projectId: item.Id }, query })
    },


    handleadded: (item) => this.$refs.ListPane.handleadded(item),
    handlechanged: (item) => this.$refs.ListPane.handlechanged(item),

    setEditItem(item) {
      this.dialogtrigger++;
      this.editItem = item;
    },
  },

  computed: {
    filters() {
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes(this.pk + "filter-"))) {
        var filters = {
          SearchWord: this.getQueryParam("filter-keyword", undefined),
          CustomerIdList: this.customersfilter,
        };
        return filters;
      }
      else {
        return null;
      }
    },

    customersfilter: {
      get() { return this.getQueryParam("filter-customers", []); },
      set(update) { this.setQueryParam("filter-customers", update); },
    },

    externaltrigger() { return this.$store.state.triggerevents.previewTrigger; },
  },

  watch: {
    externaltrigger: function () { this.setEditItem(null); }
  },
};
</script>


<style lang='scss' scoped></style>